import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=c1cf0a00"
import script from "./WhatsappIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports